import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import {
  canModifyAdminData,
  isSystemAdministrator,
  isViewOnlyRole,
} from "../utils/rbac";

export function useRbac() {
  const role = useSelector((state: RootState) => state.auth.data?.UserRole);

  return {
    role,
    isSystemAdministrator: isSystemAdministrator(role),
    isViewOnly: isViewOnlyRole(role),
    canModify: canModifyAdminData(role),
  };
}
